import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { HomeModule } from './home/home.module';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { PaymentSlipsModule } from './payment-slips/payment-slips.module';
import { SolicitudeModule } from './solicitude/solicitude.module';
import { VacationModule } from './vacation/vacation.module';
import { EmployeeModule } from './employee/employee.module';
import { ManagementModule } from './management/management.module';
import { PermissionGuard } from './core/guards/permission/permission.guard';

export const routes: Routes = [
  {
    path: '', // Redirige a la ruta base
    redirectTo: 'auth/login', // Redirige directamente a login bajo "auth"
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: 'dashboard',
    component: LayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'home',
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_INICIO_ADMIN' },
        loadChildren: () => import('./home/home.module').then((m) => HomeModule),
      },
      {
        path: 'management',
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_ADMINISTRACION_ADMIN' },
        loadChildren: () => import('./management/management.module').then((m) => ManagementModule),
      },
      {
        path: 'payment-slips',
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_BOLETAS_ADMIN' },
        loadChildren: () => import('./payment-slips/payment-slips.module').then((m) => PaymentSlipsModule),
      },
      {
        path: 'solicitude',
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_SOLICITUDES_ADMIN' },
        loadChildren: () => import('./solicitude/solicitude.module').then((m) => SolicitudeModule),
      },
      {
        path: 'vacation',
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_VACACIONES_ADMIN' },
        loadChildren: () => import('./vacation/vacation.module').then((m) => VacationModule),
      },
      {
        path: 'employee',
        canActivate: [PermissionGuard],
        data: { permission: 'VIEW_EMPLEADOS_ADMIN' },
        loadChildren: () => import('./employee/employee.module').then((m) => EmployeeModule),
      },
    ],
  },
  // {
  //   path: 'dashboard',
  //   loadChildren: () =>
  //     import('./pages/dashboard/dashboard.module').then(
  //       (m) => m.DashboardModule
  //     ),
  // },

  {
		path: 'error',
		loadChildren: () => import('./modules/errors/errors.module').then((m) => m.ErrorsModule)
	},

  {
    path: '**', // Redirige cualquier ruta no definida
    redirectTo: 'error/404',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
